module.exports = __webpack_public_path__ + "img/rgarro.abd0d685.svg";